import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routing/routeConfiguration';
import { LinkTabNavHorizontal } from '../../components';

import css from './UserNav.module.css';
import { useSelector } from 'react-redux';
import { currentUserSelector } from '../../ducks/user.duck';
import { getUserTypePreference } from '../../util/dataExtractor';
import { UserTypePreference } from '../../util/enums';

/**
 * A component that renders a navigation bar for a user-specific pages.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} props.currentPage - The current page (e.g. 'ManageListingsPage')
 * @returns {JSX.Element} User navigation component
 */
const UserNav = props => {
  const { className, rootClassName, currentPage, showManageListingsLink } = props;
  const classes = classNames(rootClassName || css.root, className);
  const currentUser = useSelector(currentUserSelector);
  const userTypePreference = getUserTypePreference(currentUser);
  const isSeller = userTypePreference === UserTypePreference.SELLER;

  const manageListingsTabMaybe = showManageListingsLink
    ? [
        {
          text: <FormattedMessage id="UserNav.yourListings" />,
          selected: currentPage === 'ManageListingsPage',
          linkProps: {
            name: 'ManageListingsPage',
          },
        },
      ]
    : [];

  const tabs = [
    // ...manageListingsTabMaybe,
    {
      text: <FormattedMessage id="UserNav.shopSettings" />,
      selected: currentPage === 'ShopSettingsPage',
      disabled: false,
      linkProps: {
        name: 'ShopSettingsPage',
      },
    },
    // {
    //   text: <FormattedMessage id="UserNav.profileSettings" />,
    //   selected: currentPage === 'ProfileSettingsPage',
    //   disabled: false,
    //   linkProps: {
    //     name: 'ProfileSettingsPage',
    //   },
    // },
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
  ];

  return (
    <LinkTabNavHorizontal className={classes} tabRootClassName={css.tab} tabs={tabs} skin="dark" />
  );
};

export default UserNav;
